import { z } from "zod";
import { channelCannotOpenSchema } from "./resource-references.js";
/** Attachment placement never changes the artifact's source access policy. */
export const artifactLinkInputSchema = z.object({
    targetType: z.enum(["channel", "record"]),
    targetId: z.string().trim().min(1).max(200),
}).strict();
export const attachArtifactResponseSchema = z.object({
    attached: z.boolean(),
    /** Attaching lists the artifact; when some of the channel's readers cannot open it, it is named here. */
    channelCannotOpen: channelCannotOpenSchema.optional(),
}).strict();
export const detachArtifactResponseSchema = z.object({ detached: z.boolean() }).strict();
